import styled from "styled-components";
import Select from "react-select";
interface Props {
  cancel?: boolean;
}

// ----------- import external dependencies ------------
export const AssModal = styled.div`
  background: var(--primaryWhiteMain);
  width: 500px;
  @media screen and (max-width: 768px) {
    width: 70%;
  }
  @media screen and (max-width: 425px) {
    width: 95%;
  }
  // height: 450px;
  min-height: max-content;
  border-radius: 15px;
  overflow-y: auto;
  overscroll-behavior-y: contain;
  /* padding: 1rem; */
  position: relative;
  padding: 2rem 2rem;
  @media screen and (max-width: 425px) {
    padding: 1rem 1.5rem;
  }

  .close-icon {
    position: absolute;
    right: 1rem;
    cursor: pointer;
  }

  .role-wrapper {
    display: flex;
    gap: 5px;
    align-items: center;

    label {
      font-size: 0.8rem;
    }
  }
`;

export const CancelDeleteButton = styled.button<Props>`
  float: right;
  min-width: 8rem;
  height: 55px;
  background: ${(props) =>
    props.cancel ? "rgb(255, 255, 255)" : "rgb(61, 0, 82)"};
  border-radius: 5px;

  color: ${(props) => (props.cancel ? "rgb(61, 0, 82)" : "rgb(255, 255, 255)")};
  font-family: "Plus Jakarta Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  border: 1px solid rgb(61, 0, 82);
  cursor: pointer;
  float: ${(props) => (props.cancel ? "left" : "right")};
  @media screen and (max-width: 425px) {
    min-width: 6rem;
    height: 40px;
  }
`;
export const RolesFormWrapper = styled.div``;
export const InputandButtonContainer = styled.div`
  display: flex;
  margin-bottom: 2rem;
  @media only screen and (max-width: 1024px) and (min-width: 769px) {
    flex-direction: column;
  }
  @media screen and (max-width: 768px) {
    flex-direction: column;
    z-index: 1099;
  }
`;
export const FormInputContainer = styled.div`
  /* border: 1px solid green; */
  width: 100%;
  display: flex;
  justify-content: space-between;

  @media screen and (min-width: 768px) {
    flex-direction: row;
  }
  flex-direction: column;
  justify-content: space-around;
  /* width: 100%; */
`;
export const ReportActionBtnContainer = styled.div`
  display: flex;
  justify-content: space-between;
  /* position: relative; */
  @media screen and (max-width: 435px) {
    flex-direction: column;
  }
  @media screen and (max-width: 320px) {
    justify-content: space-around;
  }
`;
export const ActionBtnContainer = styled.div`
  display: flex;
  width: 30%;
  justify-content: flex-end;
  align-items: flex-end;
  @media screen and (max-width: 1024px) {
    justify-content: flex-start;
    align-items: center;

    margin: 15px 0;
  }
  /* z-index: 99; */

  /* justify-content: flex-end; */
  @media screen and (max-width: 375px) {
    width: 60%;
    width: 100%;
  }
`;

// styles for RolesMultiSelect
export const StyledRolesMultiSelect = styled(Select)`
  width: 100%;
`;
// styles for user name v2 component
export const UserNameMainContainer = styled.div``;
export const UserNameContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  /* border: 1px solid gold; */
  /* padding: 0.8rem;
   */
  padding-left: 0.8rem;
  background-color: rgb(251, 248, 252);
  margin-top: 10px;
`;
// styles for contact container component
export const ContactContainer = styled.span`
  /* position: absolute;
  top: 39px; */
  z-index: 2;
  /* padding: 0.8rem;
  padding-right: 0; */
  display: flex;
  align-items: center;
  color: #b199ba;
`;
// styles for user name input
interface UserNameInputProps {
  isAvailable?: boolean;
}
export const UserNameInput = styled.input.attrs({
  className:
    "appearance-none  h-15 rounded w-full  text-gray-600 focus:outline-none",
})<UserNameInputProps>`
  display: flex;
  align-items: center;
  /* border: ${(props) => (props.isAvailable ? "none" : " 1px solid red")}; */
  /* color: ${(props) => (props.isAvailable ? "" : "red")}; */
  border: none;
  background-color: #fbf8fc;
  padding: 0.8rem;
  padding-left: 0;
  ::placeholder {
    color: #b199ba;
    font-weight: 300;
    font-size: 14px;
    width: 100%;
  }
`;
export const LoadingIcon = styled.div``;
export const Label = styled.label.attrs({
  className: "font-medium",
})`
  font-size: 14px;
  font-weight: 500;
  /* color: #b199ba; */
  margin-bottom: 5px;
  font-size: 0.8rem;
`;
export const GeneratedUserNameContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;
interface GeneratedUserNameProps {
  isAvailable: boolean;
}
export const GeneratedUserName = styled.input<GeneratedUserNameProps>`
  padding: 0.5rem;
  color: ${(props) => (props.isAvailable ? "rgb(177, 153, 186)" : "red")};
  font-weight: 300;
  font-size: 14px;
  width: 15%;
  margin-right: 7px;
  display: flex;
  justify-content: center;
  border: 1px solid
    ${(props) => (props.isAvailable ? "rgb(177, 153, 186)" : "red")};
`;
export const PBtnContainer = styled.div`
  display: flex;
  /* width: 100px; */
  height: 20px;
`;
export const AcceptBtn = styled.button`
  background-color: white;
  border: none;
  cursor: pointer;
`;
export const RejectBtn = styled(AcceptBtn)``;
export const EditBtn = styled(AcceptBtn)``;
export const SuccessMessage = styled.span`
  color: rgb(177, 153, 186);
  font-size: 0.8rem;
  font-weight: 500;
`;
